import React from 'react';

const DigitalSubscription = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle opacity="0.08" cx="14" cy="14" r="14" fill="white" />
    <g clipPath="url(#clip0)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.2353 13.5335C17.2219 12.2052 17.1318 10.8788 16.9655 9.56091C15.9747 9.69568 14.9761 9.76465 13.9761 9.76737C12.9762 9.76465 11.9776 9.69568 10.9868 9.56091C10.8205 10.8788 10.7304 12.2052 10.717 13.5335H17.2353Z"
        fill="#3448FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.33301 13.5336H9.784C9.79803 12.1598 9.89217 10.7879 10.066 9.42512C8.05271 9.0704 6.09794 8.43998 4.25679 7.55164C3.07738 9.33063 2.41169 11.4006 2.33301 13.5336H2.33301Z"
        fill="#3448FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.717 14.4668C10.7305 15.7842 10.8193 17.0998 10.983 18.4071C11.9751 18.2719 12.975 18.2028 13.9761 18.2001C14.9774 18.2028 15.9773 18.2719 16.9693 18.4071C17.1331 17.0998 17.2219 15.7842 17.2353 14.4668H10.717Z"
        fill="#3448FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.062 18.5433C9.89086 17.191 9.79803 15.8299 9.784 14.4668H2.33301C2.41172 16.5895 3.07178 18.6499 4.24121 20.4231C6.08571 19.5316 8.04449 18.899 10.062 18.5433Z"
        fill="#3448FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.8348 19.3303C14.9374 19.0774 13.0148 19.0774 11.1174 19.3303C11.288 20.444 11.547 21.5422 11.8921 22.6147C12.5949 24.7229 13.4454 25.6667 13.9765 25.6667C14.5077 25.6667 15.3578 24.7229 16.0609 22.6147C16.4057 21.5422 16.6645 20.4439 16.8348 19.3303Z"
        fill="#3448FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1223 8.63807C13.0164 8.88963 14.9355 8.88963 16.8296 8.63807C16.6595 7.53528 16.4022 6.44769 16.0604 5.3855C15.3576 3.27728 14.5071 2.3335 13.976 2.3335C13.4448 2.3335 12.5946 3.27728 11.8916 5.3855C11.5497 6.44769 11.2925 7.53528 11.1223 8.63807Z"
        fill="#3448FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.6193 14.4668H18.1683C18.1542 15.8299 18.0613 17.191 17.8901 18.5433C19.9077 18.899 21.8665 19.5317 23.711 20.4232C24.8804 18.6499 25.5405 16.5895 25.6193 14.4668Z"
        fill="#FFC85F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.2017 8.50081C10.4378 6.3599 11.1502 4.29899 12.2865 2.46924C9.337 2.89858 6.66455 4.44292 4.81982 6.78404C6.52977 7.59228 8.33959 8.16959 10.2017 8.50081Z"
        fill="#3448FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.7556 19.4675C17.5211 21.6195 16.8069 23.6915 15.6658 25.531C18.6255 25.0998 21.3056 23.5459 23.1504 21.1916C21.4367 20.3798 19.6224 19.8001 17.7556 19.4675Z"
        fill="#FFC85F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1964 19.4675C8.32961 19.8001 6.51543 20.3798 4.80176 21.1916C6.64649 23.5459 9.32664 25.0998 12.2863 25.531C11.1452 23.6915 10.431 21.6195 10.1964 19.4675Z"
        fill="#3448FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.7503 8.50081C19.6124 8.16957 21.4221 7.59225 23.1319 6.78404C21.2872 4.44292 18.6148 2.89858 15.6653 2.46924C16.8017 4.29897 17.5142 6.35988 17.7503 8.50081Z"
        fill="#FFC85F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.8862 9.42512C18.06 10.7879 18.1542 12.1598 18.1682 13.5336H25.6192C25.5405 11.4006 24.8748 9.33063 23.6954 7.55164C21.8542 8.43998 19.8995 9.0704 17.8862 9.42512Z"
        fill="#FFC85F"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect
          width="23.3333"
          height="23.3333"
          fill="white"
          transform="translate(2.33301 2.3335)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default DigitalSubscription;
